import { Edit, Trash } from "react-feather";
import { useAuth } from "../../../global-components/src";
import { Post } from "../../../types";
import PermissionCheck from "../../PermissionCheck";
import React, { useEffect } from 'react';
import { Pencil, Trash2 } from "lucide-react";
import { User } from "../../../global-components/src/types";
import { t } from "i18next";

interface PostActionsProps {
    post: Post; 
    userOwner?: User; 
    onEdit: (post: Post) => void; 
    onDelete: (post: Post) => void; // Adicione a função onDelete
}

const PostActions: React.FC<PostActionsProps> = ({ post, onEdit, onDelete, userOwner }) => {
    const { user, isSuper } = useAuth();

    return (    
        <li>
            {post?.id_user ? (
                <>
                    {!post.deleted_at ? (
                        <PermissionCheck just_owner={true} permission="edit_post" id_owner={post?.id_user}>
                            <span onClick={() => onEdit(post)} className="dropdown-item cursor-pointer user-select-none">
                                <div className="div-icon-fix" style={{display: "flex", alignItems: "center"}} data-bs-toggle="modal" data-bs-target="#modal-edit-post">
                                    <Pencil data-feather="edit" className="icon-config-post"/> {t("post.actions.edit")}
                                </div>
                            </span>
                        </PermissionCheck>
                    ): null}

                    <PermissionCheck permission="delete_post" id_owner={post?.id_user}>
                        {userOwner && user && (user?.position < userOwner?.position || !userOwner?.position && user?.position || isSuper() || user.id == post.id_user) ? (
                            <span onClick={() => onDelete(post)} className="dropdown-item cursor-pointer user-select-none">
                                <div className="div-icon-fix" style={{display: "flex", alignItems: "center"}}>
                                    <Trash2 data-feather="edit" className="icon-config-post"/> {t("post.actions.delete")}
                                </div>
                            </span>
                        ) : null}
                    </PermissionCheck>
                </>
            ) : null}
        </li>
    );
};

export default PostActions;
